import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Common } from '@stockbit/ui';
import Link from 'next/link';

// header components
import { selectors as profileSelectors } from 'lib/entities/profile';
import { selectors as credentialsSelectors } from 'lib/entities/credentials';
import { ORDER_TYPE } from 'constants/trading';
import useTradingAccount from 'hooks/useTradingAccount';
import tradingModalStore from 'global/TradingModal/store';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import shallow from 'zustand/shallow';
import { Mobile as SearchMobile } from './Search';
import { Mobile as NavbarMobile } from './Navbar';
import { Mobile as MessageMobile } from './Message';
import { Mobile as NotificationMobile } from './Notification';
import { Mobile as ProfileMenuMobile } from './ProfileMenu';
import SearchCompanyModal from './SearchCompanyModal';
import { HeaderMobile, ProUser } from './styled';

const { Flex } = Common;

const Mobile = () => {
  const { data } = useSelector(profileSelectors);
  const [isShowSearchCompanyModal, closeSearchCompanyModal] =
    useSearchCompanyModalStore((s) => [s.visible, s.closeModal], shallow);
  const { isLoggedIn } = useSelector(credentialsSelectors);
  const { isRealTrading } = useTradingAccount();
  const showTradingModal = tradingModalStore((s) => s.showModal);
  const getUnreadCount = useNotificationData((store) => store.getUnreadCount);

  useEffect(() => {
    if (isLoggedIn) {
      getUnreadCount();
    }
  }, []);

  const onSymbolChange = (newSymbol) => {
    closeSearchCompanyModal();
    showTradingModal({
      symbol: newSymbol,
      orderType: isRealTrading ? ORDER_TYPE.BUY : ORDER_TYPE.VIRTUAL_BUY,
    });
  };

  return (
    <HeaderMobile id="stockbit-header-mobile">
      <Flex align="center">
        <NavbarMobile />
        <SearchMobile />
      </Flex>
      <Flex align="center">
        {!data.ispro ? (
          <Link href="/shop">
            <ProUser>Berlangganan Pro</ProUser>
          </Link>
        ) : null}
        <MessageMobile />
        <NotificationMobile />
        <ProfileMenuMobile />
      </Flex>
      {isShowSearchCompanyModal && (
        <SearchCompanyModal
          onSymbolChange={(symbol) => onSymbolChange(symbol)}
        />
      )}
    </HeaderMobile>
  );
};

export default Mobile;
